import { captureException } from '@sentry/nextjs';
import axios from 'axios';
import { MutationFunction, useMutation, useQueryClient } from 'react-query';

import { WalletNotRegisteredError } from '~/../api/common.types';

import { UseSetAttackTypes } from './useSetAttack.types';

const setAttack: MutationFunction<any, any> = async ({
  warriorId,
  contextId,
  battleId,
  attack,
  token,
}: UseSetAttackTypes) => {
  const apiHost = process.env.NEXT_PUBLIC_API_HOST;
  const payload = {
    attack: attack,
  };
    // const contextId = TOURNAMENTS[tournamentType].apiContext;
  const url = `${apiHost}/context/${contextId}/state/${battleId}/warrior/${warriorId}/attack`;
  const { data } = await axios({
    url: url,
    method: 'put',
    data: payload,
    headers: {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });
  return data.attack;
};

export const useSetAttack = () => {
  const queryClient = useQueryClient();
  return useMutation(setAttack, {
    retry: (failureCount, error: any | WalletNotRegisteredError) => {
      if (error?.response?.data?.errors) {
        const err = error.response.data['errors'][0];
        if (err?.code === 'context:wallet-not-registered') {
          return false;
        }
      }
      console.log('error', error);
      captureException(error);
      if (failureCount >= 5) {
        return false;
      }
      return true;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
};
